import { render, staticRenderFns } from "./CheckingWords.vue?vue&type=template&id=26a9844f&scoped=true&"
import script from "./CheckingWords.vue?vue&type=script&lang=js&"
export * from "./CheckingWords.vue?vue&type=script&lang=js&"
import style0 from "./CheckingWords.vue?vue&type=style&index=0&id=26a9844f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a9844f",
  null
  
)

export default component.exports